<template>
    <el-button @click="view" type="primary" size="small" >
        <i class="fa fa-mail-forward"></i>
    </el-button>
</template>

<script>
    export default {
        name: "VideoBtn",
        props: {
            text: {},
            row: {},
        },
        methods: {
            view() {
                // console.log(this.row)
                // this.$store.dispatch('d2admin/page/open', {
                //     name: 'heannyByUrl',
                // })
                // location.href = '/#/heanny/'+encodeURIComponent(this.row.url)
                window.open(this.row.url);
            }
        },
    }
</script>

<style scoped>

</style>